module.exports = __webpack_public_path__ + "img/show-img5.7f22cc57.png";